// data grid
import {Column} from "./BasicDataGrid";

export interface SelectableColumn extends Column {
    visible: boolean;
}

export const makeSelectable = (column: Column, visible: boolean = true): SelectableColumn => {
    column.visible = visible;
    return column as SelectableColumn;
};



// WEBPACK FOOTER //
// ./src/components/ColumnSelection.tsx